@import (reference) '../../../../../constants/spacing.module.less';

.service-name {
  color: var(--light--text-color--1);

  &.is-voided {
    text-decoration: line-through currentcolor;
  }
}

.service-and-tracking-container {
  justify-content: center;
}

.label-actions-button-icon {
  width: 24px;
  height: 24px;
  color: var(--light--icon--fill-color--1);
}

.label-details {
  justify-content: space-between;
}

.label-info {
  justify-content: space-between;
  align-items: center;
  gap: @space-16;
}

.label-actions-dropdown-menu {
  height: fit-content;
}
